import React, { FC } from "react";

import { Chip, ChipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledChip = styled(Chip)(({ theme }) => ({}));

/**
 * @see Chip
 */
export const IgChip: FC<ChipProps> = (props) => {
  const { children, ...rest } = props;

  return <StyledChip {...rest}>{children}</StyledChip>;
};
